<template>
  <dl class="project">
    <dt class="project-header">
      <h2 class="project-header__title">攻略/榜单/专题</h2>
      <router-link class="project-link__more" to="/special">
        <span>更多</span>
        <i class="el-icon-arrow-right"></i>
      </router-link>
    </dt>
    <dd class="project-body">
      <!-- 轮播图 -->
      <swiper class="project-left" :options="swiperOptions">
        <swiper-slide v-for="(item, i) in food.list" :key="i">
          <a
            class="swiper-item"
            target="_blank"
            :href="`/detail/${item.id}?topic=${item.property.topics[0].englishName}` | hostBuild('forum')"
          >
            <YorkbbsImage class="swiper-cover" :src="item.property.coverImage | webpFormat(300)">
              <div class="swiper-label">
                <i class="yk-info_sound"></i>
                <span>美食采访专栏</span>
              </div>
            </YorkbbsImage>
            <div class="swiper-title e">{{ item.title }}</div>
          </a>
        </swiper-slide>
        <div class="swiper-pagination" slot="pagination"></div>
      </swiper>

      <!-- 列表 -->
      <div class="project-right">
        <a
          class="project-item"
          :href="detailURL(item)"
          v-for="(item, i) in life.list"
          :key="i"
        >
          <YorkbbsImage
            class="project-cover"
            animation
            :src="item.property.coverImage[0] | webpFormat(150)"
          ></YorkbbsImage>
          <div class="project-item__right">
            <div class="project-title e-2">{{ item.property.title || item.title }}</div>
            <div class="project-subtitle" v-if="item.property.shortDescription">
              {{ item.property.shortDescription }}
            </div>
          </div>
        </a>
      </div>
    </dd>
  </dl>
</template>
<script>
import { hostBuild } from '@/utils/utils';
export default {
  name: 'Project',
  data() {
    return {
      swiperOptions: {
        autoplay: true,
        spaceBetween: 15,
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
      },

      // 美食专栏
      food: {
        loading: false,
        list: [],
      },

      // 生活专题
      life: {
        loading: false,
        list: [],
      },
    };
  },
  created() {
    this.getFoodSpecial();
    this.getLifeSpecial();
  },
  methods: {
    detailURL(itemData) {
      //return hostBuild(`/special/${this.topicType == 1 ? 'big' : 'small'}/${this.data.id}`, 'info');
      if (itemData.property.jumpLink) {
        return itemData.property.jumpLink;
      } else if (itemData.property.cmsType === 3) {
        return hostBuild(`/special/${itemData.property.topicType == 1 ? 'big' : 'small'}/${itemData.id}`, 'info');
      } else if(itemData.property.cmsType == 6 ){
        return hostBuild(`/specials/subject/${itemData.id}`,'news') ;
      }else if ([2, 4].includes(itemData.property.cmsType)) {
        return hostBuild(`/feature/${itemData.englishName}/${itemData.id}`,'news');
      }

      return hostBuild(`/detail/${itemData.englishName}/${itemData.id}`,'news');
    },
    /**
     * 获取美食专栏
     */
    async getFoodSpecial() {
      this.food.loading = true;
      const { data } = await this.$axios.post('/info/v1/get/eat/topicpost/top/data', { size: 5 }).finally(() => {
        this.food.loading = false;
      });
      this.food.list = data;
    },
    /**
     * 获取生活专题
     */
    
    async getLifeSpecial() {
      this.life.loading = true;
      const { data } = await this.$axios
        .post('/cms/v2/get/post/list', {
          offset: 1,
          size: 4,
          sort: ['property_updatedAt: DESC'],
          "options":{"cmsType":[2,3,4,6]},
        })
        .finally(() => {
          this.life.loading = false;
        });

      this.life.list = data.items;
    },
  },
};
</script>
<style lang="scss" scoped>
.project {
  margin-top: 30px;
}
.project-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}
.project-header__title {
  font-size: 20px;
  font-weight: 500;
  line-height: 28px;
}
.project-link__more {
  font-size: 15px;
  line-height: 21px;
  &:hover {
    color: var(--primary-color);
  }
}

.project-body {
  display: flex;
  justify-content: space-between;
  min-height: 200px;
}

.project-left {
  width: 300px;
  padding-left: 10px;
  margin-left: -10px;
}

.swiper-item {
  display: block;
  position: relative;
}

.swiper-cover {
  width: 300px;
  height: 200px;
  border-radius: 6px;
  border: 1px solid #eee;
}

.swiper-label {
  line-height: 35px;
  padding: 0 15px;

  font-size: 16px;
  color: #fff;
  background: linear-gradient(168deg, #ff8300, #ff0000);
  border-radius: 4px;

  position: absolute;
  left: -10px;
  top: 10px;
  z-index: 1;

  i {
    font-size: 14px;
    margin-right: 5px;
  }
}

.swiper-title {
  box-sizing: border-box;
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1;

  line-height: 40px;
  background: rgba(0, 0, 0, 0.6);
  border-radius: 0px 0px 6px 6px;

  font-size: 14px;
  color: #fff;
  padding: 0 15px;
  &:hover {
    opacity: 0.8;
  }
}

.project-right {
  box-sizing: border-box;
  width: 840px;
  // border: 1px solid #eeeeee;
  border-radius: 4px;
  // padding: 16px 24px;

  display: flex;
  flex-wrap: wrap;
  align-content: space-between;
}

.project-item {
  width: 50%;

  display: flex;
}

.project-cover {
  width: 120px;
  height: 90px;
  border-radius: 4px;
  border: 1px solid #eeeeee;
}

.project-item__right {
  flex: 1;
  padding: 0 15px;
}

.project-title {
  font-size: 16px;
  color: var(--text-color-3);
  line-height: 24px;
  margin-bottom: 10px;
  &:hover {
    color: var(--primary-color);
  }
}

.project-subtitle {
  display: inline-block;
  font-size: 14px;
  color: var(--text-color-9);
  line-height: 20px;
}

.project-left {
  ::v-deep {
    .swiper-pagination {
      box-sizing: border-box;
      text-align: right;
      padding-right: 20px;
    }
    .swiper-pagination-bullet-active {
      background-color: var(--primary-color);
    }
  }
}
</style>
